<template lang="pug">
div
  main.promo
    Twitch(
      :twitchDone="twitch_done",
      :twitchUser="twitch_user",
      :showBlock="show_block")
    Faq
    Download
  MainFooter
  ProjectRegistrationForm
  UserTransfer
</template>

<script>
import env from "@godweb/frontend-base/src/libs/tools/Environment";
import ProjectRegistrationForm from "@godweb/frontend-base/src/components/register/mygames/ProjectReg.vue";
import UserTransfer from "@static_promo_pages/common/components/user_transfer/vue/UserTransfer";
import UserMixin from "@godweb/frontend-base/src/mixins/user/UserMixin";

import MainFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import Twitch from "./blocks/Twitch";
import Faq from "./blocks/Faq";
import Download from "./blocks/Download";

export default {
  name: "Index",

  components: {
    MainFooter,
    ProjectRegistrationForm,
    Twitch,
    Faq,
    Download,
    UserTransfer,
  },

  mixins: [UserMixin],

  data() {
    return {
      promo_name: "twitchdrops",
      twitch_done: false,
      twitch_user: null,
      show_block: false,
    };
  },

  computed: {
    isMyGames() {
      return env.isMyGames();
    },
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.initPromo();
    });
  },

  methods: {
    async initPromo() {
      await this.$store.dispatch("global/auth");
      if (this.isUserInProject) {
        this.requestTwitchUserData();
      } else {
        this.checkUser();
      }
    },

    requestTwitchUserData() {
      return this.$api.twitchDropsService
        .getUser()
        .run()
        .then(response => {
          this.show_block = true;
          if (!response.data.error) {
            this.twitch_done = true;
            this.twitch_user = response.data;
          }
        });
    },

    checkUser() {
      this.show_block = true;
    },
  },
};
</script>
